// E-commerce State Management
let cart = JSON.parse(localStorage.getItem("signage_cart")) || [];
let wishlist = JSON.parse(localStorage.getItem("signage_wishlist")) || [];

function updateCartUI() {
  const count = cart.length;
  const countEls = document.querySelectorAll("#cart-count");
  countEls.forEach((el) => {
    el.textContent = count;
    el.style.display = count > 0 ? "flex" : "none";
  });

  localStorage.setItem("signage_cart", JSON.stringify(cart));
  renderCartDrawer();
}

function renderCartDrawer() {
  const container = document.getElementById("cart-drawer-content");
  const totalEl = document.getElementById("cart-total-amount");
  if (!container || !totalEl) return;

  if (cart.length === 0) {
    container.innerHTML = `
      <div class="signage__cart-empty">
        <span class="material-symbols-outlined">shopping_basket</span>
        <p>Your cart is currently empty.</p>
      </div>
    `;
    totalEl.textContent = "$0.00";
    return;
  }

  let total = 0;
  container.innerHTML = cart
    .map((item, index) => {
      total += item.price;
      return `
      <div class="signage__cart-item">
        <div class="signage__cart-item-info">
          <div class="signage__cart-item-title">${item.title}</div>
          <div class="signage__cart-item-original-title">${item.original_title || ""}</div>
          <div class="signage__cart-item-price">$${item.price}.00</div>
        </div>
        <button class="signage__cart-item-remove" onclick="removeFromCart(${index})">
          <span class="material-symbols-outlined">delete</span>
        </button>
      </div>
    `;
    })
    .join("");
  totalEl.textContent = `$${total}.00`;
}

function toggleCartDrawer() {
  const drawer = document.getElementById("cart-drawer");
  const overlay = document.getElementById("cart-overlay");
  if (drawer && overlay) {
    drawer.classList.toggle("active");
    overlay.classList.toggle("active");
    if (drawer.classList.contains("active")) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }
}
 /**************************************
   * FAQ TOGGLE
   **************************************/
  function toggleFaq(trigger) {
    const item = trigger.closest('.faq-item');
    const icon = trigger.querySelector('.material-symbols-outlined');
    const isOpen = item.classList.contains('active');

    // Close all others
    document.querySelectorAll('.faq-item.active').forEach((el) => {
      el.classList.remove('active');
      const ic = el.querySelector('.faq-trigger .material-symbols-outlined');
      if (ic) ic.textContent = 'add';
    });

    if (!isOpen) {
      item.classList.add('active');
      if (icon) icon.textContent = 'remove';
    }
  }

function removeFromCart(index) {
  cart.splice(index, 1);
  updateCartUI();
}

function updateWishlistUI() {
  // Update header counter
  const wishlistCountEls = document.querySelectorAll("#wishlist-count");
  wishlistCountEls.forEach((el) => {
    el.textContent = wishlist.length;
    el.style.display = wishlist.length > 0 ? "flex" : "none";
  });

  localStorage.setItem("signage_wishlist", JSON.stringify(wishlist));
  // Update all wishlist buttons on the page
  document
    .querySelectorAll(
      ".signage__collections-card-wishlist, .signage__product-wishlist-btn, .wishlist",
    )
    .forEach((btn) => {
      const title = btn.getAttribute("data-title");
      if (title && wishlist.includes(title)) {
        btn.classList.add("active");
      } else {
        btn.classList.remove("active");
      }
    });
}

function toggleWishlist(btn, title) {
  if (event) event.preventDefault();
  const index = wishlist.indexOf(title);
  if (index === -1) {
    wishlist.push(title);
    showToast(`Added ${title} to Wishlist`, "favorite");
  } else {
    wishlist.splice(index, 1);
    showToast(`Removed ${title} from Wishlist`, "heart_minus");
  }
  updateWishlistUI();
}

// function addToCart(title, price, original_title = '') {
//     if (event) event.preventDefault();
//     cart.push({ title, price, original_title });
//     updateCartUI();
//     showToast(`Added ${title} to Cart`, 'shopping_cart');
// }

async function createProductAndGetVariantId(productPayload) {
  const res = await fetch(
     `${UPSELL_API.endpoint}/create-product`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Shop-Domain": UPSELL_API.shop
      },
      body: JSON.stringify(productPayload),
    },
  );

  const data = await res.json();

  if (!data?.success) {
    console.error("❌ create-product failed for:", productPayload?.title, data);
    return null;
  }

  return data?.data?.product?.variants?.[0]?.id || null;
}

async function addBundleToCart(btn, productIds, bundleName) {
  const card = btn.closest(".signage__bundle-card, .signage__crosssell-bundle-card");
  const bundlePrice = parseFloat(card?.dataset.bundlePrice || 0);
  const individualTotal = parseFloat(card?.dataset.individualTotal || bundlePrice);
  const originalText = btn.textContent.trim();
  const loadingClass = btn.classList.contains("signage__bundle-cta")
    ? "signage__bundle-cta--loading"
    : "signage__crosssell-bundle-btn--loading";

  const resetBtn = () => {
    btn.classList.remove(loadingClass);
    btn.innerHTML = originalText;
  };

  btn.classList.add(loadingClass);
  btn.innerHTML = `<span class="signage__btn-spinner"></span> Adding…`;

  showToast(`Adding "${bundleName}" to Cart…`, "shopping_bag");

  try {
    const finalData =
      typeof getFinalSignageData === "function"
        ? await getFinalSignageData()
        : null;

    // Collect included product titles and first product's image for the bundle
    const includedProducts = productIds
      .map((id) => finalData?.signage_collections?.find((p) => p.id === id))
      .filter(Boolean);

    const bundlePayload = {
      title: bundleName + " for " + customer_name,
      discounted_price: bundlePrice,
      actual_price: individualTotal || bundlePrice,
      image: includedProducts[0]?.image || "",
      images: includedProducts.map((p) => p.image).filter(Boolean),
      description: `Bundle includes: ${includedProducts.map((p) => p.title).join(", ")}`,
      tag: "Bundle",
      category: "Bundle",
    };

    // console.log("bundlePayload", bundlePayload)
    // return;

    const variantId = await createProductAndGetVariantId(bundlePayload);

    if (!variantId) {
      showToast("Failed to add bundle to cart.", "error");
      resetBtn();
      return;
    }

    await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
      }),
    });

    showToast(`Bundle "${bundleName}" added to Cart`, "shopping_bag");
    resetBtn();
    window.location.href = "/cart";
  } catch (err) {
    console.error("Bundle add-to-cart error:", err);
    showToast("Failed to add bundle to cart.", "error");
    resetBtn();
  }
}

function selectOption(btn) {
  const group = btn.closest(".option-buttons, .size-grid");
  if (!group) return;
  group.querySelectorAll("button").forEach((b) => b.classList.remove("active"));
  btn.classList.add("active");
}

function onSizeRangeChange(input) {
  const index = parseInt(input.value);
  const prices = input.dataset.prices.split(",").map(Number);
  const sizes = input.dataset.sizes.split(",");
  const price = prices[index];
  const size = sizes[index];

  // Handle bundle cards: data-prices holds raw collective sum; apply discount for display
  const bundleCard = input.closest(".signage__bundle-card");
  if (bundleCard) {
    const discount = parseFloat(bundleCard.dataset.bundleDiscount || 0.1);
    const bundlePrice = Math.round(price * (1 - discount) * 100) / 100;
    const savings = Math.round(price * discount * 100) / 100;

    bundleCard.dataset.bundlePrice = bundlePrice;
    bundleCard.dataset.individualTotal = price;

    const nowEl = bundleCard.querySelector(".signage__bundle-now");
    const wasEl = bundleCard.querySelector(".signage__bundle-was");
    const saveEl = bundleCard.querySelector(".signage__bundle-save");
    const currentEl = bundleCard.querySelector(".signage__size-range-current");

    if (nowEl) nowEl.textContent = `$${bundlePrice}`;
    if (wasEl) wasEl.textContent = `Was $${price}`;
    if (saveEl) saveEl.textContent = `Save $${savings}`;
    if (currentEl) currentEl.textContent = size;

    // Update each product row's individual price
    bundleCard.querySelectorAll(".signage__bundle-product-item").forEach((item) => {
      const itemPrices = item.dataset.prices ? item.dataset.prices.split(",").map(Number) : [];
      const itemPrice = itemPrices[index] ?? itemPrices[0];
      const priceEl = item.querySelector(".signage__bundle-product-price");
      if (priceEl && itemPrice) priceEl.textContent = `$${itemPrice}`;
    });

    const pct = prices.length > 1 ? (index / (prices.length - 1)) * 100 : 0;
    input.style.setProperty("--fill-pct", pct + "%");
    bundleCard.querySelectorAll(".signage__size-range-tick").forEach((tick, i) => {
      tick.classList.toggle("active", i === index);
    });
    return;
  }

  const card = input.closest(".signage__crosssell-card, .signage__collections-card");
  if (!card) return;

  card.dataset.selectedPrice = price;
  card.dataset.selectedSize = size;

  const priceEl = card.querySelector(".signage__crosssell-card-price, .signage__collections-card-price-discount");
  if (priceEl) priceEl.textContent = "$" + price;

  // Update size header display
  const currentEl = card.querySelector(".signage__size-range-current");
  if (currentEl) currentEl.textContent = size;

  // Update fill bar
  const pct = prices.length > 1 ? (index / (prices.length - 1)) * 100 : 0;
  input.style.setProperty("--fill-pct", pct + "%");

  // Update tick highlights
  card.querySelectorAll(".signage__size-range-tick").forEach((tick, i) => {
    tick.classList.toggle("active", i === index);
  });
}

function onSizeRangeTickClick(tick, index) {
  const card = tick.closest(".signage__crosssell-card, .signage__collections-card, .signage__bundle-card");
  if (!card) return;
  const input = card.querySelector(".signage__size-range-input");
  if (!input) return;
  input.value = index;
  onSizeRangeChange(input);
}

// Toast System Logic
function showToast(message, icon = "check_circle") {
  const container = document.getElementById("toast-container");
  if (!container) return;

  const toast = document.createElement("div");
  toast.className = "signage__toast";
  toast.innerHTML = `
    <span class="material-symbols-outlined signage__toast-icon">${icon}</span>
    <span>${message}</span>
  `;
  container.appendChild(toast);

  // Trigger reflow for animation
  setTimeout(() => toast.classList.add("show"), 10);

  // Remove after 3 seconds
  setTimeout(() => {
    toast.classList.remove("show");
    setTimeout(() => toast.remove(), 400);
  }, 3000);
}

// remove up-sale from title

function removeUpSaleFromTitle(productTitle){
  return productTitle.replace(/up-sale/gi, "").trim()
}

// Reset all loading buttons when page is restored from bfcache (browser back button)
window.addEventListener("pageshow", (e) => {
  if (e.persisted) {
    document.querySelectorAll(
      ".signage__bundle-cta--loading, .signage__crosssell-bundle-btn--loading, .signage__collections-action-btn--loading, .signage__crosssell-card-btn--loading"
    ).forEach((btn) => {
      btn.classList.remove(
        "signage__bundle-cta--loading",
        "signage__crosssell-bundle-btn--loading",
        "signage__collections-action-btn--loading",
        "signage__crosssell-card-btn--loading"
      );
      btn.disabled = false;
    });

    // Also reset product CTA on single product page
    document.querySelectorAll(".signage__product-cta").forEach((btn) => {
      btn.disabled = false;
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  updateCartUI();
  updateWishlistUI();

  // Mobile Menu Logic (Shared)
  const mobileNav = document.getElementById("signage__collections-mobile-nav");
  const mobileToggleBtn = document.getElementById(
    "signage__collections-mobile-menu-btn",
  );

  if (mobileToggleBtn && mobileNav) {
    mobileToggleBtn.addEventListener("click", () => {
      mobileNav.classList.toggle("active");
      const icon = mobileToggleBtn.querySelector(".material-symbols-outlined");
      if (icon) {
        icon.textContent = mobileNav.classList.contains("active")
          ? "close"
          : "menu";
      }
    });

    // Close mobile nav on link click
    document
      .querySelectorAll(".signage__collections-mobile-nav-link")
      .forEach((link) => {
        link.addEventListener("click", () => {
          mobileNav.classList.remove("active");
          if (mobileToggleBtn.querySelector(".material-symbols-outlined")) {
            mobileToggleBtn.querySelector(
              ".material-symbols-outlined",
            ).textContent = "menu";
          }
        });
      });
  }

  // Gallery/Lightbox logic
  const galleryItems = document.querySelectorAll(".gallery-item");
  const lightbox = document.getElementById("lightbox");
  if (lightbox) {
    const lightboxImg = lightbox.querySelector(".lightbox-image");
    const lightboxCaption = lightbox.querySelector(".lightbox-caption");
    const closeBtn = lightbox.querySelector(".lightbox-close");

    galleryItems.forEach((item) => {
      item.addEventListener("click", () => {
        const img = item.querySelector("img");
        const title = item.querySelector("h3").textContent;
        if (lightboxImg) lightboxImg.src = img.src;
        if (lightboxCaption) lightboxCaption.textContent = title;
        lightbox.classList.add("active");
        document.body.style.overflow = "hidden";
      });
    });

    const closeLightbox = () => {
      lightbox.classList.remove("active");
      document.body.style.overflow = "";
    };

    if (closeBtn) closeBtn.addEventListener("click", closeLightbox);
    lightbox.addEventListener("click", (e) => {
      if (e.target === lightbox) closeLightbox();
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && lightbox.classList.contains("active")) {
        closeLightbox();
      }
    });
  }
});
